import { render, staticRenderFns } from "./EatOffers.vue?vue&type=template&id=8d4fabb0&"
import script from "./EatOffers.vue?vue&type=script&lang=js&"
export * from "./EatOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports